export default __webpack_public_path__ + "cf8c288dea30b9dc0f0d3244d7fe3a20.svg";